<template>
  <v-dialog
    :model-value="modelValue"
    max-width="960"
    scrollable
    @update:model-value="$emit('update:modelValue', $event)"
    @click:outside="$emit('update:modelValue', false)"
  >
    <v-card v-if="wallpaper" class="preview-card" rounded="xl">
      <div class="preview-image-wrap">
        <v-img
          :src="previewImageSrc"
          :alt="wallpaper.title"
          max-height="70vh"
          contain
          class="preview-image"
        />
      </div>

      <v-card-item class="preview-meta">
        <v-card-title class="preview-title">
          {{ wallpaper.title }}
        </v-card-title>
        <v-chip
          class="preview-category-chip"
          color="#8b5cf6"
          variant="tonal"
          size="small"
          rounded="lg"
        >
          {{ wallpaper.category }}
        </v-chip>
      </v-card-item>

      <v-card-actions class="preview-actions">
        <v-btn variant="text" rounded="lg" @click="$emit('update:modelValue', false)">
          Close
        </v-btn>
        <v-spacer />
        <v-btn
          class="download-btn"
          variant="flat"
          rounded="xl"
          :loading="downloading"
          @click="$emit('download', wallpaper)"
        >
          <v-icon icon="mdi-download" start size="20" />
          Download
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDisplayImageUrl } from '@/services/publicS3Upload'

export default {
  name: 'WallpaperPreviewDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    wallpaper: {
      type: Object,
      default: null
    },
    downloading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'download'],
  computed: {
    previewImageSrc() {
      return getDisplayImageUrl(this.wallpaper?.imageUrl)
    }
  }
}
</script>

<style scoped>
.preview-card {
  background: #ffffff;
  color: #0f172a;
  overflow: hidden;
}

.preview-image-wrap {
  background: #0f172a;
  padding: 12px;
}

.preview-image {
  width: 100%;
  border-radius: 12px;
}

.preview-meta {
  padding: 20px 24px 8px !important;
}

.preview-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  padding: 0;
  white-space: normal;
  line-height: 1.25;
}

.preview-category-chip {
  margin-top: 10px;
  font-weight: 600;
}

.preview-actions {
  padding: 8px 20px 22px;
}

.download-btn {
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 55%, #a855f7 100%) !important;
  color: #fff !important;
  font-weight: 600;
  text-transform: none;
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35) !important;
}
</style>
